import { render, staticRenderFns } from "./AddDashboardModal.vue?vue&type=template&id=d5eeffba"
import script from "./AddDashboardModal.vue?vue&type=script&lang=js"
export * from "./AddDashboardModal.vue?vue&type=script&lang=js"
import style0 from "./AddDashboardModal.vue?vue&type=style&index=0&id=d5eeffba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports